import { defineMessages } from 'react-intl';

export const warningIndicatorMessages = defineMessages({
  directRecoveryOfDebt: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.third_party_holder_notice',
    defaultMessage: '{icon} <b>Notice of third party holder</b>',
    description: 'Label of notice of third party holder',
  },
  thirdPartyHolderNotice: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.third_party_holder_notice',
    defaultMessage: '{icon} <b>Notice of third party holder</b>',
    description: 'Label of notice of third party holder',
  },
  bankAccountSeizure: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.bank_account_seizure',
    defaultMessage: '{icon} <b>Bank account seizure</b>',
    description: 'Label of bank account seizure',
  },
  bankAccountSeizureModal: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.bank_account_seizure_modal',
    defaultMessage: 'Bank account seizure',
    description: 'Label of bank account seizure',
  },
  thirdPartyHolderNoticeModal: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.third_party_holder_notice_modal',
    defaultMessage: 'Direct Recovery of Debts',
    description: 'Label of direct Recovery of Debts',
  },
  internationalTransfers: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.international_transfers',
    defaultMessage: '{icon} <b>International transfers</b>',
    description: 'Label of international transfers',
  },
  internationalTransfersModal: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.international_transfers_modal',
    defaultMessage: 'International transfers',
    description: 'Label of international transfers',
  },
  bankTransactionsToBeJustified: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.bank_transactions_to_be_justified',
    defaultMessage: '{icon} <b>Bank transactions to be justified</b>',
    description: 'Label of bank transactions to be justified',
  },
  bankTransactionsToBeJustifiedModal: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.bank_transactions_to_be_justified_modal',
    defaultMessage: 'Bank transactions to be justified',
    description: 'Label of bank transactions to be justified',
  },
  internalTransfersWithoutRelatedTransactionsModal: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.internal_transfers_without_related_transactions_modal',
    defaultMessage: 'Account-to-account transfers',
    description: 'Label of internal transfers without related transactions',
  },
  accountToAccountTransfers: {
    id: 'widgets.debt_consolidation_synthesis.indicators.warning_indicator_label.account_to_account_transfers',
    defaultMessage: '{icon} <b>Account-to-account transfers{count, select, undefined {} 0 {} other {: {count}}}</b>',
    description: 'Label of account-to-account transfers',
  },
});
